import { useRef } from 'react'
import {
  Marker,
  useMap
} from 'react-leaflet'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import {
  MODAL_SECTION,
  UNSUPPORTED_MAX_ZOOM_LEVEL
} from 'utils/constants'
import { createEventMarkerColor } from 'utils/helpers'
import {
  markersSelectors,
  setEventId,
  setEventData,
  setSelectedEventData,
  usersSelectors,
  setChatSectionPage,
  setUserSectionPage,
  setOpenPopupBlogs,
  setOpenPopupEvents,
  setNotificationSectionPage,
  setBlogRepostData,
  handleOpenModal,
  setSelectedMarkerData
} from 'store'
import { v4 as uuid } from 'uuid'

export const EventMarkerItem = ({ eventItem }) => {
  const eventMarkerRef = useRef(null)
  const dispatch = useDispatch()
  let mouseDownOnMarkerRef = useRef(false)
  const { selectedEventData } = useSelector(markersSelectors)
  const {
    openPopupEvents,
    profileItemId
  } = useSelector(usersSelectors)

  const map = useMap()

  const [searchParams, setSearchParams] = useSearchParams()
  const eventid = eventItem?.id

  const markerPostForPopup = () => {
    if (eventItem.lat >= 84.8) {
      // eslint-disable-next-line no-underscore-dangle
      map.setView(eventMarkerRef?.current?._latlng, UNSUPPORTED_MAX_ZOOM_LEVEL)

      return 500
    }

    if (eventItem.lat >= 84.6) {
      // eslint-disable-next-line no-underscore-dangle
      map.setView(eventMarkerRef?.current?._latlng, 21)

      return 500
    }

    if (eventItem.lat >= 83.6) {
      // eslint-disable-next-line no-underscore-dangle
      map.setView(eventMarkerRef?.current?._latlng, 19)

      return 500
    }

    if (eventItem.lat >= 60) {
      // eslint-disable-next-line no-underscore-dangle
      map.setView(eventMarkerRef?.current?._latlng, 7)

      return 500
    }

    return 0
  }

  const handleSelectedEventMarkerData = () => {
    setTimeout(() => {
      dispatch(setEventId(eventItem?.id))
      dispatch(setSelectedEventData(eventItem))
    }, markerPostForPopup())
  }

  const handleClick = () => {
    document.querySelector('#custom-popup-overlay')?.click()
    document.querySelector('#custom-popup-overlay-event')?.click()
    dispatch(setChatSectionPage('clear'))
    dispatch(setUserSectionPage('clear'))
    dispatch(setOpenPopupBlogs(false))
    dispatch(setOpenPopupEvents(false))
    dispatch(setNotificationSectionPage('clear'))
    dispatch(setBlogRepostData([]))
    dispatch(handleOpenModal({
      isOpen: false,
      section: MODAL_SECTION.RightSection
    }))

    setTimeout(() => {
      dispatch(setEventId(null))
      dispatch(setSelectedMarkerData(null))
      dispatch(setSelectedEventData(null))
      dispatch(setEventData())
      setSearchParams({ eventid })

      handleSelectedEventMarkerData()
    }, selectedEventData || profileItemId ? 1200 : 0)
  }

  setTimeout(() => {
    if (
      eventMarkerRef.current
      && +sessionStorage.getItem('eventid') === eventid
      && selectedEventData?.id !== eventid
      && !openPopupEvents
    ) {
      handleSelectedEventMarkerData()
    }
  }, 500)

  const eventIconMarker = createEventMarkerColor(eventItem?.start_date)

  return (
    <Marker
      key={uuid()}
      eventHandlers={{
        click: () => {
          if (eventItem?.lat < 84.5) {
            handleClick()
          }
        },
        mousedown: () => {
          mouseDownOnMarkerRef.current = true
        },
        mouseup: () => {
          if (mouseDownOnMarkerRef.current && eventItem?.lat >= 84.5) {
            handleClick()
          }

          mouseDownOnMarkerRef.current = false
        },
        mouseout: () => {
          mouseDownOnMarkerRef.current = false
        },
        touchStart: () => {
          mouseDownOnMarkerRef.current = true
        },
        touchEnd: () => {
          if (mouseDownOnMarkerRef.current && eventItem?.lat >= 84.5) {
            handleClick()
          }

          mouseDownOnMarkerRef.current = false
        },
        touchCancel: () => {
          mouseDownOnMarkerRef.current = false
        }
      }}
      position={[eventItem?.lat, eventItem?.lng]}
      zIndexOffset={999}
      className="event-marker"
      icon={eventIconMarker}
      title={eventItem.id}
      ref={eventMarkerRef}
    />
  )
}
